<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";
export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["TabloId", "DonemId", "Sorgulama","BirimId","UstDonemId"],
  components: {
        Loader,
    },
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Birimid: "",
      TableData: [],
      TableDataDetails: [],
      bugun: null,
      BirimAdi: "",
      DonemAdi: "",
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId(){
      this.Get();
    },
    BirimId(){
      this.Get();
    }
  },

  methods: {
    Get() {

      let Filter = "&Tanimid=" + this.TabloId + "&Birimid=" + this.BirimId + "&Ustdonemid=" + this.UstDonemId + "&Donemid=" + this.DonemId

      this.ActionsFilterGet({ Service: "StrRaporlama/GetBirimHedefTutturmaOranlariTablosu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data[0].Detay;
          this.BirimAdi = res.Data[0].Birimadi
            
      this.ActionsGet({ Service: "StrPerfDonem/" + this.DonemId, Page: this.Page }).then((res) => {
        if (res) {
          this.DonemAdi = res.Data.Aciklama;

        }

      });
      });

    },
    ExcelExport(table, name){  
                if (!table.nodeType) table = this.$refs.spbirimgostergedegerlendirmeformu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
    }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
      <Loader>
  <div>
   
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Stratejik Plan Değerlendirme Tablosu',
                  'Stratejik Plan Değerlendirme Tablosu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


   

  
    <div ref="spbirimgostergedegerlendirmeformu" class="table-responsive">

      <div>

      <table>
      
        <tbody>

          <tr><td>

           <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
            <tbody> 
              <tr>
              <td style="background-color:rgb(7, 156, 165); font-weight: bold; text-align: center;" scope="col" colspan="6">Birim Gösterge Değerlendirme Tablosu</td>
              </tr>
              <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight: bold;" scope="col" colspan="1">Birim Adı</td>
            <td colspan="5">{{ BirimAdi }}</td>
          </tr>
          <tr>
            <td style="background-color:rgb(7, 156, 165); font-weight: bold;" scope="col" colspan="1">Dönemi</td>
            <td colspan="5">{{ DonemAdi }}</td>
          </tr>
 
          </tbody>
          </table>

          </td></tr>
          <tr>
            <td>

              <div class="table-responsive">
   
           <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
                 <tbody>
                   <tr>
                  <th style="background-color:rgb(7, 156, 165);text-align:center;">Gösterge</th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Hedef </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Gerçekleşme </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Oran </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Göstergeye İlişkin Sapmanın Nedeni </th>
                   <th style="background-color:rgb(7, 156, 165);text-align:center;"> Göstergeye İlişkin Alınacak Önlemler </th>

                   </tr>
                    <tr v-for="(SubData, index) in TableData" :key="index">
                      <td :key="index" >{{ SubData.Gos }}</td>
                      <td style="text-align:center;">{{ SubData.Hh }}</td>                   
                      <td style="text-align:center;">{{ SubData.Gh }}</td>
                      <td style="text-align:center;">{{ SubData.So }}</td>
                      <td style="text-align:center;" v-html="SubData.Sapmanedeni"></td>
                      <td style="text-align:center;" v-html="SubData.Alinacakonlem"></td>
                   </tr>

                 </tbody> 

               </table> 

              </div>

            </td>
          </tr>
        </tbody>
      </table>
     </div>

      <br />
    </div>
  </div>
</Loader>
</template>
